interface UboxRewardShowProps {
  List: string;
  Name: string;
  Pc?: string;
  Color?: string;
  Note?: string | null;
}

export default function UboxRewardShow(props: UboxRewardShowProps) {
  return (
    <div className="container card card-ufa-category border-ufa-grey shadow">
      <div className="heading margin-left-10">
        <div className="row">
          <div className="col-12">
            <div>
              <h4>
                <span>{props.List}</span>{" "}
              </h4>
            </div>
          </div>
        </div>
        <div className="bottom-line-yellow margin-bottom-10"></div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-8 margin-top-3 color-font-card">{props.Name}</div>
          <div className="text-right col-4">
            <h4>
              <span
                style={{
                  fontSize: 16,
                  color: props.Color == null ? "" : props.Color,
                }}
              >
                {props.Pc}
              </span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}
